import { DOCTORS, leumitSearchClient } from "assets/constants";
import { InstantSearch, Configure } from "react-instantsearch";
import React from "react";
import HitsResults from "./HitsResults";
import styles from "./DoctorsInBranch.module.scss";
import { DoctorsSearchBox } from "./doctorsSearchBox";
const queryString = window.location.search;
const urlSearchParams = new URLSearchParams(queryString);

const getBranchNum = () => {
const branchNum = urlSearchParams.get('branchNum') || '';
return `${branchNum}`;
}

const getSubBranchNum = () => {
    const subBranchNum = urlSearchParams.get('subBranchNum') || '';
    return `${subBranchNum}`;
   }

export function DoctorsInBranch() {
  return (
    <div className={styles.searchDoctors}>
      <InstantSearch
        indexName={DOCTORS}
        searchClient={leumitSearchClient}
      >
        <Configure filters={`medicalCenter.branchNum:'${getBranchNum()}' AND medicalCenter.subBranchNum:'${getSubBranchNum()}'`} hitsPerPage={9}/>
        <DoctorsSearchBox />
        <HitsResults/>
        </InstantSearch>
        </div>
  );
}